import React from "react";
import { X } from "lucide-react";
import { EXPLORATION_SKILLS } from "../types";
import { useGame } from "../context/GameContext";
import { useForceSaveOnUnmount } from "../hooks/useAutoSave";

interface AddExplorationSkillModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AddExplorationSkillModal: React.FC<AddExplorationSkillModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { addExplorationSkill } = useGame();

  // Force save when modal closes
  useForceSaveOnUnmount();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-3">
      <div className="ledger-shell max-w-md w-full text-sm">
        <div className="p-4 flex justify-between items-center">
          <h2 className="text-base font-semibold uppercase tracking-wider">Add Exploration Skill</h2>
          <button
            onClick={onClose}
            className="text-[#E6E5D3] hover:text-white"
          >
            <X size={20} />
          </button>
        </div>

        <div className="p-4">
          <div className="flex flex-wrap gap-2">
            {EXPLORATION_SKILLS.map((skill) => (
              <button
                key={skill}
                onClick={() => {
                  addExplorationSkill(skill);
                  onClose();
                }}
                className="ledger-btn text-xs px-3 py-2 font-semibold uppercase tracking-wider transition-colors"
              >
                {skill}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
